<div class="body">
    <p class="p-txtgrande margin-bot0">COMPARTILHE SUA LOJA</p>

    <div class="div-img-compartilhe">
        <a href="https://homolog.portaldoalunocurso.com.br/afiliado/loja" target="_blank">
            <img class="img-compartilhe" src="../../../../../assets/compartilhar1.png" alt="img_compartilhar">
        </a>
        <a href="https://www.facebook.com/sharer/sharer.php?u=https://homolog.portaldoalunocurso.com.br/afiliado/loja" target="_blank">
            <img class="img-compartilhe" src="../../../../../assets/facebook1.png" alt="img_compartilhar">
        </a>
        <a href="https://api.whatsapp.com/send?text=https://homolog.portaldoalunocurso.com.br/afiliado/loja" target="_blank">
            <img class="img-compartilhe" src="../../../../../assets/whatsapp1.png" alt="img_compartilhar">
        </a>
        <!-- <a href="https://www.instagram.com/create/select/" target="_blank">
            <img class="img-compartilhe" src="../../../../../assets/instagram1.png" alt="img_compartilhar">
        </a> -->
        <a href="https://t.me/share/url?url=https://homolog.portaldoalunocurso.com.br/afiliado/loja" target="_blank">
            <img class="img-compartilhe" src="../../../../../assets/telegram1.png" alt="img_compartilhar">
        </a>
        <a href="mailto:?subject=Visite a minha Loja Virtual&body=Acesse o link https://homolog.portaldoalunocurso.com.br/afiliado/loja para adquirir o seu curso com desconto." target="_blank">
            <img class="img-compartilhe" src="../../../../../assets/email1.png" alt="img_compartilhar">
        </a>
    </div>

    <p class="p-txt centro">Utilize suas redes sociais para divulgar sua <br>
        Loja Virtual e oferecer produtos e serviços exclusivos! <br>
    </p>

</div>